import { v4 as uuidv4 } from 'uuid'


class ObjectStorage {
    
  constructor(store_key) {

      this.id =  uuidv4()

      let data = window.localStorage.getItem(store_key)
      if (data) {
          this.store = JSON.parse(data)
      } else {
          this.store = {}
      }

      this.channel = new BroadcastChannel(store_key)
      this.channel.onmessage = (evt) => {
          if (evt.data.storage != this.id) {
              this.setReactiveItem(evt.data.key, evt.data.item, false)     
          }
      }

      window.addEventListener("beforeunload", () => {
          if (this.getItem("self.destructor")) {
              window.localStorage.removeItem(store_key)
          } else {
              window.localStorage.setItem(store_key, JSON.stringify(this.store))
          }
      })
      this.listeners = {}
  }


  subscribe(obj, key) {
      if (!this.listeners[key]) {
          this.listeners[key] = []
      }
      if (this.listeners[key].indexOf(obj) < 0) {
          this.listeners[key].push(obj)
      }
  }


  unsubscribe(obj, key) {
      if (this.listeners[key] && this.listeners[key].indexOf(obj) >= 0) {
          this.listeners[key].splice(this.listeners[key].indexOf(obj), 1)
      }
  }


  setReactiveItem(key, item, message = true) {
      this.setItem(key, item, message)
      if (this.listeners[key]) {
          for (let listener of this.listeners[key]) {
              listener.storageCallback(key, item)
          }
      }
  }

  makeItem(key, item, message = true) {
      if (!(key in this.store)) {
          this.setItem(key, item, message)
      } 
  }

  setItem(key, item, message = true) {
      if (this.store[key] !== item) {
          this.store[key] = item
          if (message) {
              this.channel.postMessage({key: key, item: item, storage: this.id})
          }
      }
  }

  getItem(key) {
      return structuredClone(this.store[key])
  }
}


window.objectStorage = new ObjectStorage("main.storage")



export const DisplayMode = {
  Search: 'Search',
  Section: 'Section'
}

export function transposeObject(object) {
    let result = []
    for (const key in object) {
      if (result.length) {
        for (let [n, r] of Object.entries(result)) {
          r[key] = object[key][n]
        }
      } else {
        for (let [n, v] of Object.entries(object[key])) {
          result.push({[key] : v})
        }
      }
    }
    return result
}


export function visibleInContainer(ele, container) {
    const eleTop = ele.offsetTop
    const eleBottom = eleTop + ele.clientHeight

    const containerTop = container.scrollTop
    const containerBottom = containerTop + container.clientHeight

    return (
        (eleTop >= containerTop && eleBottom <= containerBottom)
    )
}


export function phoneFormat(s, plus = true) {
    let phone = s.replace(/[^0-9]/g, '')
    
    if (phone.startsWith('7') || phone.startsWith('8')) {
        return phone.substr(1).replace(/(\d{3})(\d{3})(\d{2})(\d{2})/g, `+7 ($1) $2 $3 $4`)
    }
    if (phone.startsWith('38')) {
        return phone.substr(2).replace(/(\d{3})(\d{3})(\d{2})(\d{2})/g, `+38 ($1) $2 $3 $4`)
    } 
}


export function makeCenteredRect(width, height, offsetx = 0, offsety = 0) {
  let cx = width ? ((window.innerWidth / 2) - (width / 2)) + offsetx : 0
  let cy = height ? ((window.innerHeight / 2) - (height / 2)) + offsety : 0
  return new DOMRect(cx, cy, width, height)
}


export function singleShotTransition(node, selector, duration) {
  var style = document.createElement("style")
  style.classList.add("injected")
  style.innerHTML = `${selector} { transition: ${duration} }`
  
  node.appendChild(style)
  node.addEventListener("transitionend", () => {
    node.querySelector("style.injected").remove()
   }, { once: true })
}


export class AJAXProcessor {
    genericQuery(action, data, callback, handler, extract=true) {
        BX.ajax.runAction(action, {
          data: data,
        }).then(resp => {
          callback && callback(extract ? Object.values(resp.data) : resp.data)
        }).catch(err => {
          handler && handler(err)
        })
    }

    rawQuery(action, data, callback, handler) {

      let params = Object.entries(data).map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)

      let url = `/bitrix/services/main/ajax.php?action=${encodeURIComponent(action)}&${params.join("&")}`,
          xhr = new XMLHttpRequest()
      
      xhr.open("GET", url, true);
      xhr.responseType = "blob"

      xhr.setRequestHeader("X-Bitrix-Csrf-Token", BX.bitrix_sessid())
      xhr.setRequestHeader("X-Bitrix-Site-Id", BX.message.SITE_ID)
  
      xhr.onload = function() {

          if (this.status === 200) {
            callback(this.response)
          } else {
            handler(this.status);
          }
      }
      xhr.send()
    }


    authorizedAction(handler, action) {
      BX.ajax.runAction('uad:shop.api.registration.isAuthorized', {}).then(resp => {
        if (resp.data) {
          handler()
        } else {
          action ? action() : openAuthPanel()
        }
      }).catch(err => {
        console.error(err)
        action ? action() : openAuthPanel()
      })
    }

    // Авторизация

    authorize(creds, callback, handler) {
      this.genericQuery('uad:shop.api.registration.authorize', creds, callback, handler, false)
    }

    logout(callback, handler) {
      this.genericQuery('uad:shop.api.registration.logout', {}, callback, handler, false)
    }

    getCaptcha(callback, handler) {
      this.genericQuery('uad:shop.api.registration.getCaptcha', {}, callback, handler, false)
    }

    restorePassword(dataset, callback, handler) {
      this.genericQuery('uad:shop.api.registration.restorePassword', dataset, callback, handler, false)
    }

    changePassword(dataset, callback, handler) {
      this.genericQuery('uad:shop.api.registration.changePassword', dataset, callback, handler, false)
    }

    
    // Каталог

    getTree(callback, handler) {
      this.genericQuery('uad:shop.api.content.getCatalogStructureJson', {}, callback, handler, false)
    }
  
    fetchFromSection(filter, callback, handler) {
      this.genericQuery('uad:shop.api.item.fromSection', { filter: filter }, callback, handler)    
    }
  
    fetchFromSearch(filter, callback, handler) {
      this.genericQuery('uad:shop.api.search.querySearch', { filter: filter }, callback, handler) 
    }
  
    fetchFromSuggestion(filter, callback, handler) {
      this.genericQuery('uad:shop.api.search.querySuggestion', { filter: filter }, callback, handler) 
    }
  
    fetchPrices(ids, callback, handler) {
      this.genericQuery('uad:shop.api.sale.fetchPrices', { ids: ids }, callback, handler, false)
    }

    fetchAnalogs(id, callback, handler) {
      this.genericQuery('uad:shop.api.item.getAnalogs', { id: id}, callback, handler, false)   
    }

    previewOrder(callback, handler) {
      this.genericQuery('uad:shop.api.order.preview', {}, callback, handler, false)
    }

    makeOrder(payload, callback, handler) {
      this.genericQuery('uad:shop.api.order.make', payload, callback, handler, false)
    }

    listOrders(callback, handler) {
      this.genericQuery('uad:shop.api.order.getList', {}, callback, handler, false)
    }

    getStatusTable(callback, handler) {
      this.genericQuery('uad:shop.api.order.getStatusTable', {}, callback, handler, false)
    }

    avatarHistory(callback, handler) {
      this.genericQuery('uad:shop.api.customer.avatarHistory', {}, callback, handler, false)
    }

    statusHistory(selector, callback, handler) {
      this.genericQuery('uad:shop.api.order.getStatusHistory', selector, callback, handler, false)
    }

    loadBasketItems(callback, handler) {
      this.genericQuery('uad:shop.api.sale.getCartContent', {}, callback, handler, false)
    }

    addBasketItem(id, quantity, callback, handler) {
      this.genericQuery('uad:shop.api.sale.addToCart', { item_id: id, quantity: quantity}, callback, handler)
    }

    keepBasketItem(id, callback, handler) {
      this.genericQuery('uad:shop.api.sale.keepBasketItem', {id: id}, callback, handler, false)
    }

    removeBasketItem(id, callback, handler) {
      this.genericQuery('uad:shop.api.sale.removeBasketItem', {id: id}, callback, handler, false)
    }

    delayBasketItem(id, callback, handler) {
      this.genericQuery('uad:shop.api.sale.delayItemsFromCart', {selection: [id]}, callback, handler, false)
    }

    restoreBasketItem(id, callback, handler) {
      this.genericQuery('uad:shop.api.sale.restoreItemsToCart', {selection: [id]}, callback, handler, false)
    }

    updateQuantity(quantity, id, callback, handler) {
      let payload = {
          item_id: id,
          new_quantity: quantity
      }
      this.genericQuery('uad:shop.api.sale.updateItemQuantity', payload, callback, handler, false)
    }

    getUgautodetalClientTypes(callback, handler) {
      this.genericQuery('uad:shop.api.sale.getUgautodetalClientTypes', {}, callback, handler, false)
    }

    getUgautodetalClientGroups(callback, handler) {
      this.genericQuery('uad:shop.api.sale.getUgautodetalClientGroups', {}, callback, handler, false)
    }

    registerClient(payload, callback, handler) {
      this.genericQuery('uad:shop.api.registration.registerClient', {input: payload}, callback, handler, false)
    }

    getClientProfile(callback, handler) {
      this.genericQuery('uad:shop.api.customer.getProfile', {}, callback, handler, false)
    }

    getAllUsers(callback, handler) {
      this.genericQuery('uad:shop.api.customer.getAll', {}, callback, handler, false)
    }

    // AP CHAT 

    getModeratorGroups(callback, handler) {
      this.genericQuery('uad:shop.api.chat.getModeratorGroups', {}, callback, handler, false)
    }

    getChatGroups(callback, handler) {
      this.genericQuery('uad:shop.api.chat.getGroups', {}, callback, handler, false)
    }

    getChatMessages(group, callback, handler) {
      this.genericQuery('uad:shop.api.chat.getMessages', {group: group}, callback, handler, false)
    }

    getMsgAttachment(msgId, attId, callback, handler) {
      this.rawQuery('uad:shop.api.chat.getAttachment', {msgId: msgId, attId: attId}, callback, handler)
    }

    getCurrentProfile(callback, handler) {
      this.genericQuery('uad:shop.api.chat.getCurrentProfile', {}, callback, handler, false)
    }

    activateSubscriptions(callback, handler) {
      this.genericQuery('uad:shop.api.chat.activateSubscriptions', {}, callback, handler, false)
    }

    clearNotifications(group, callback, handler) {
      this.genericQuery('uad:shop.api.chat.clearNotifications', {group: group}, callback, handler, false)
    }
}



export class Price {
  
  static formatter = new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency: 'RUB',
    maximumFractionDigits: 2
  })
  
  static format(number) {
    return this.formatter.format(number)
  }

  constructor(price, markup) {
    this.price = price
    this.markup = markup
  }
  
  get value() {
    return price + (price * markup * 0.1)
  }

  priceString(quantity = 1) {
    return Price.format(price * quantity)
  }

  valueString(quantity = 1) {
    return Price.format((price + (price * markup * 0.1)) * quantity)
  }
}